import { render, staticRenderFns } from "./yiStory.vue?vue&type=template&id=5c6bd2ae&scoped=true&"
import script from "./yiStory.vue?vue&type=script&lang=js&"
export * from "./yiStory.vue?vue&type=script&lang=js&"
import style0 from "./yiStory.vue?vue&type=style&index=0&id=5c6bd2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6bd2ae",
  null
  
)

export default component.exports